// Importing necessary libraries and components
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useSnackbar } from "notistack";
import moment from "moment";

import { Grid } from "@mui/material";

import AppLoader from "../AppLoader/Index";
import { profileCodePermissionCheck } from "../../Utils/commonUtils";

import {
  getMerchantListData,
  getManagerListDataNames,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
} from "../../Redux/Actions/merchantInformation";
import {
  sendInviteManagerApiCall,
  submitWebhookApiCall,
} from "../../actions/Operations";

// Custom styles for the WebhookModal component
const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    borderRadius: 8,
    maxWidth: 600,
    width: "90%",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(3),
  },
  inputRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },
}));

// WebhookModal component definition
const WebhookApiModal = ({
  onClose,
  props,
  rows,
  Bussines_id,
  rowForEdit,

  handleRefresh,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [firstName, setFirstName] = useState("");
  const menu = JSON.parse(localStorage.getItem("menu"));

  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [phoneNumber, setPhone] = useState("");

  const [selectedRows, setSelectedRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false); // State to manage loading state
  const [businessName, setBusinessName] = useState(null);
  const [businessType, setBusinessType] = useState("");
  const selectedBusiness = null;
  const selectedGroupVisibility = useState(null);
  const [platformType, setPlatformType] = useState();
  const [buttonFlag, setButtonFlag] = useState(false);
  const dispatch = useDispatch();
  const [notificationFileSize, setNotificationFileSize] = useState("25600");
  const [statusFileSize, setStatusFileSize] = useState("");
  const profileCode = menu?.Role_Permission_Data?.Profile_Code;
  const accountAccessibility = [];
  const Manager_uid_Storage = localStorage.getItem("Merchant_uid");
  const Manager_uid = Manager_uid_Storage ? JSON.parse(Manager_uid_Storage) : "";
  const User_Id = localStorage.getItem("User_Id");
  const [errorNotification, setErrorNotification] = useState(false);
  const [errorMessageNotification, setErrorMessageNotification] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);
  const [errorMessageStatus, setErrorMessageStatus] = useState("");
  const [errorNotificationFileSize, setErrorNotificationFileSize] = useState(false);
  const [errorMessageNotificationFileSize, setErrorMessageNotificationFileSize] = useState("");
  const businessNameData = localStorage.getItem("businessName");

  // State variables for form inputs and modal behavior
  const [inputValueNotification, setInputValueNotification] = useState("");
  const [inputValueStatus, setInputValueStatus] = useState("");
  const [statusCreatedDate, setStatusCreatedDate] = useState("");
  const [notificationCreatedDate, setNotificationCreatedDate] = useState("");
  // Effect to populate webhook data for editing
  React.useEffect(() => {
    if (rowForEdit) {
      const setStatusValueHandle = () => {
        if (rowForEdit?.Webhook) {
          for (const item of rowForEdit.Webhook) {
            if (item.type === "status") {
              setInputValueStatus(item.URL);

              setStatusCreatedDate(
                item.Created_Date
                  ? moment(item.Created_Date)
                    .tz("America/New_York")
                    .format("MM/DD/YYYY hh:mm A")
                  : ""
              );
            }
          }
        }
      };

      const setNotificationValueHandle = () => {
        if (rowForEdit?.Webhook) {
          for (const item of rowForEdit.Webhook) {
            if (item.type === "notification") {
              setInputValueNotification(item.URL);

              setNotificationCreatedDate(
                item.Created_Date
                  ? moment(item.Created_Date)
                    .tz("America/New_York")
                    .format("MM/DD/YYYY hh:mm A")
                  : ""
              );
            }
          }
        }
      };

      setStatusValueHandle();
      setNotificationValueHandle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, rowForEdit]);

  React.useEffect(() => {
    if (businessNameData) {
      setBusinessName(
        <Select
          labelId="business-name"
          id="business-name"
          disabled
          value={businessNameData}
          required
        >
          {rows.map((row) => (
            <MenuItem value={`${row.Business_Name}`}>
              {row.Business_Name}
            </MenuItem>
          ))}
        </Select>
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Bussines_id, businessNameData]);

  React.useEffect(() => {
    if (rowForEdit.User_Merchant_AcctLinks_Details) {
      // Extract Group_Visibility array and set it to selectedRows
      const userMerchantAcctLinksDetails =
        rowForEdit?.User_Merchant_AcctLinks_Details || [];
      setSelectedRows(userMerchantAcctLinksDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  React.useEffect(() => {
    if (rowForEdit?.Webhook && Array.isArray(rowForEdit.Webhook)) {
      const notification = rowForEdit.Webhook.find(
        (w) => w.type === "notification"
      );
      const status = rowForEdit.Webhook.find((w) => w.type === "status");

      if (notification) {
        setInputValueNotification(notification.URL || "");
        setNotificationFileSize(notification.File_Size_KB || "25600");
        setNotificationCreatedDate(
          notification.Created_Date
            ? moment(notification.Created_Date)
              .tz("America/New_York")
              .format("MM/DD/YYYY hh:mm A")
            : ""
        );
      }

      if (status) {
        setInputValueStatus(status.URL || "");
        setStatusFileSize(status.File_Size_KB || "");
        setStatusCreatedDate(
          status.Created_Date
            ? moment(status.Created_Date)
              .tz("America/New_York")
              .format("MM/DD/YYYY hh:mm A")
            : ""
        );
      }
    }
  }, [rowForEdit]);

  // Function to handle notification URL input
  const handleInfoNotification = (e) => {
    const value = e.target.value;
    setInputValueNotification(e.target.value);
    // URL validation regex

    // URL validation regex
    const urlPattern =
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(:\d{1,5})?(\/.*)?$/;

    if (value && !urlPattern.test(value)) {
      setErrorNotification(true);
      setErrorMessageNotification(
        "Enter a valid URL (e.g., https://example.com)"
      );
    } else {
      setErrorNotification(false);
      setErrorMessageNotification("");
    }
  };
  const handleNotificationFileSizeChange = (e) => {
    const value = e.target.value;

    setNotificationFileSize(value);

    if (value === "") {
      setErrorNotificationFileSize(false);
      setErrorMessageNotificationFileSize("");
      return;
    }

    if (Number(value) <= 0) {
      setErrorNotificationFileSize(true);
      setErrorMessageNotificationFileSize(
        "Notification Webhook File Size must be greater than 0."
      );
      return;
    }

    setErrorNotificationFileSize(false);
    setErrorMessageNotificationFileSize("");
  };
  const handleNotificationFileSizeBlur = () => {
    if (notificationFileSize === "") {
      setNotificationFileSize("25600");
      setErrorNotificationFileSize(false);
      setErrorMessageNotificationFileSize("");
      return;
    }

    if (Number(notificationFileSize) <= 0) {
      setErrorNotificationFileSize(true);
      setErrorMessageNotificationFileSize(
        "Notification Webhook File Size must be greater than 0."
      );
    }
  };

  // Function to handle status URL input
  // const handleInfoStatus = (e) => {
  //   const value = e.target.value;
  //   setInputValueStatus(value);
  //   // URL validation regex
  //   const urlPattern =
  //     /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(:\d{1,5})?(\/.*)?$/;

  //   if (value && !urlPattern.test(value)) {
  //     setErrorStatus(true);
  //     setErrorMessageStatus("Enter a valid URL (e.g., https://example.com)");
  //   } else {
  //     setErrorStatus(false);
  //     setErrorMessageStatus("");
  //   }
  // };

  // Function to handle form submission
  const onFormSubmit = () => {
    const today = new Date();
    const webhookUrl = [];

    // Build Notification webhook
    if (inputValueNotification) {
      webhookUrl.push({
        URL: inputValueNotification,
        type: "notification",
        Created_Date: notificationCreatedDate || today,
        Created_By: rowForEdit?.Created_By,
        File_Size_KB: notificationFileSize || "",
      });
    }

    // Build Status webhook
    if (inputValueStatus) {
      webhookUrl.push({
        URL: inputValueStatus,
        type: "status",
        Created_Date: statusCreatedDate || today,
        Created_By: rowForEdit?.Created_By,
        File_Size_KB: statusFileSize || "",
      });
    }

    const payload = {
      Business_ID: rowForEdit?.Id,
      Webhook: webhookUrl,
    };

    props.submitWebhookApiCall(
      payload,
      (res) => {
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, { variant: "success" });
          onClose();
          handleRefresh();
        }
      },
      (error) => {
        enqueueSnackbar(`${error.message}`, { variant: "error" });
      }
    );
  };

  const onFormSendInvite = () => {
    if (!firstName || !lastName || !email || !phoneNumber || !businessName) {
      enqueueSnackbar("Please fill out all required fields.", {
        variant: "error",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      enqueueSnackbar("Please enter a valid email address.", {
        variant: "error",
      });
      return;
    }
    const startsWithNumberRegex = /^\d/;
    if (
      startsWithNumberRegex.test(firstName) ||
      startsWithNumberRegex.test(lastName)
    ) {
      enqueueSnackbar("First/Last name cannot start with a number.", {
        variant: "error",
      });
      return;
    }
    setLoading(true); // Set loading state to true when API call starts
    const businessId =
      Bussines_id == null ? selectedBusiness?._id : Bussines_id;
    props.sendInviteManagerApiCall(
      {
        firstName: firstName.charAt(0).toUpperCase() + firstName.slice(1),
        lastName: lastName.charAt(0).toUpperCase() + lastName.slice(1),
        email: email.toLowerCase(),
        phoneNumber,
        businessName,
        Status_Code: 1,
        accountAccessibility,
        Group_Visibility: selectedGroupVisibility,
        Platform_Accessibility: platformType,
        groupCodes: selectedRows,
        Bussines_id: businessId,
        Profile_id: Manager_uid,
        User_Id,
        Type: `${profileCode === profileCodePermissionCheck.profileCode.VCS
          ? businessType
          : "sub"
          }`,
      },
      (res) => {
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, {
            variant: "success",
          });
          setLoading(false); // Set loading state to false when API call is successful
          onClose();
          handleRefresh();
        }
      },
      (error) => {
        setLoading(false); // Set loading state to false when API call fails
        enqueueSnackbar(`${error.message}`, {
          variant: "error",
        });
      }
    );
  };
  React.useEffect(() => {
    if (rowForEdit.Business_Name) {
      setBusinessName(rowForEdit?.Business_Name);
      setButtonFlag(true);
      setPlatformType(rowForEdit.Platform_Accessibility);
      setBusinessType(rowForEdit.Type);
    } else {
      setButtonFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit]);

  React.useEffect(() => {
    if (props?.merchantListData?.emailListData?.data && email) {
      const emailExists =
        props.merchantListData.emailListData.data.includes(email);
      if (emailExists) {
        dispatch(getEmailData(email));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailListData?.data, email]);

  React.useEffect(() => {
    if (props?.merchantListData?.emailData) {
      const { First_Name, Last_Name, Phone_Number } =
        props?.merchantListData?.emailData;
      setFirstName(First_Name || "");
      setLastName(Last_Name || "");
      setPhone(Phone_Number || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailData]);
  React.useEffect(() => {
    if (rowForEdit) {
      const {
        Email, First_Name, Last_Name, Phone_Number,
      } = rowForEdit;
      setFirstName(First_Name || "");
      setLastName(Last_Name || "");
      setPhone(Phone_Number || "");
      setEmail(Email || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit]);

  React.useEffect(
    () => () => {
      dispatch(emptyEmailListReduxState());
    },
    [dispatch]
  );

  // Handle input field blur (when user clicks outside)

  return (
    <>
      <AppLoader loader={loading} />
      <Modal open onClose={onClose}>
        <div className={classes.paper}>
          <h2>Webhook Setup</h2>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className={classes.inputContainer}>
              <Grid container spacing={2}>
                <Grid
                  style={{
                    textAlign: "start",
                  }}
                  item
                  lg={3}
                  sm={3}
                  xs={3}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      paddingRight: "0px",
                    }}
                  >
                    Business Name
                  </div>
                </Grid>
                <Grid
                  style={{
                    textAlign: "start",
                    paddingLeft: "0px",
                  }}
                  item
                  lg={6}
                  sm={6}
                  xs={6}
                >
                  :&nbsp;&nbsp;
                  {businessName}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  style={{
                    textAlign: "start",
                  }}
                  item
                  lg={3}
                  sm={3}
                  xs={3}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      paddingRight: "0px",
                    }}
                  >
                    Email
                  </div>
                </Grid>
                <Grid
                  style={{
                    textAlign: "start",
                    paddingLeft: "0px",
                  }}
                  item
                  lg={6}
                  sm={6}
                  xs={6}
                >
                  :&nbsp;&nbsp;
                  {email}
                </Grid>
              </Grid>

              <div>
                <Grid container spacing={2}>
                  <Grid
                    item
                    lg={12}
                    sm={12}
                    xs={12}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <TextField
                      label="Notifications Webhook URL"
                      variant="outlined"
                      value={inputValueNotification}
                      onChange={handleInfoNotification}
                      required
                      fullWidth
                      error={errorNotification}
                      helperText={errorMessageNotification}
                    />
                  </Grid>

                  {/* New notification file size field */}
                  <Grid item lg={12} sm={12} xs={12}>
                    <TextField
                      label="Notification Webhook File Size (kb)"
                      type="number"
                      variant="outlined"
                      value={notificationFileSize}
                      onChange={handleNotificationFileSizeChange}
                      onBlur={handleNotificationFileSizeBlur}
                      fullWidth
                      style={{ marginTop: "10px" }}
                      error={errorNotificationFileSize}
                      helperText={errorMessageNotificationFileSize}
                      inputProps={{ min: 1 }}
                    />
                  </Grid>

                  {/* <Grid
                    item
                    lg={12}
                    sm={12}
                    xs={12}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <TextField
                      label="Transaction Status Webhook URL"
                      variant="outlined"
                      value={inputValueStatus}
                      onChange={handleInfoStatus}
                      required
                      fullWidth
                      error={errorStatus}
                      helperText={errorMessageStatus}
                    />
                  </Grid> */}
                  {/* 
                  New status file size field
                  <Grid item lg={12} sm={12} xs={12}>
                    <TextField
                      label="Transaction Status File Size (KB)"
                      type="number"
                      variant="outlined"
                      value={statusFileSize}
                      onChange={(e) => setStatusFileSize(e.target.value)}
                      fullWidth
                      style={{ marginTop: "10px" }}
                      inputProps={{ min: 0 }}
                    />
                  </Grid> */}
                </Grid>
              </div>
            </div>
            {buttonFlag === true ? (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!inputValueNotification || errorNotification || errorNotificationFileSize
                  // || !inputValueStatus
                }
                className={classes.button}
                onClick={onFormSubmit}
              >
                Submit{" "}
              </Button>
            ) : (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={onFormSendInvite}
              >
                Send Invite
              </Button>
            )}
          </form>
        </div>
      </Modal>
    </>
  );
};

// Prop types for the WebhookModal component
WebhookApiModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  sendInviteManagerApiCall: PropTypes.func,
  submitWebhookApiCall: PropTypes.func,
  getManagerListDataNames: PropTypes.func,
  getMerchantListData: PropTypes.func,
  getEmailList: PropTypes.func,

  getEmailData: PropTypes.func,
  emptyEmailListReduxState: PropTypes.func,
};

// Mapping Redux state to props
const mapStateToProps = (app) => ({
  formData: app.provideRegistration,
  mainData: app,
  roles: app.roles,
  app: app.app,
  signUpData: app,
  merchantListData: app.merchantInformation,
  managerListData: app.merchantInformation,
});

// Connecting the component to Redux
export default connect(mapStateToProps, {
  sendInviteManagerApiCall,
  submitWebhookApiCall,
  getMerchantListData,
  getManagerListDataNames,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
})(WebhookApiModal);
